<template>
  <LayoutShell wide>
    <slot />
  </LayoutShell>
</template>
